<template>
  <v-layout justify-center>
    <v-flex :class="columns">
      <v-form @submit.prevent="onClickButton" ref="form_creator" v-model="isValid" lazy-validation>
        <v-container>
          <v-layout wrap >

            <v-flex :class="[item.columns, (item.type === 'hidden' ? 'hidden' : '')]" v-for="(item, i) in fields" :key="i" v-show="item.visible !== undefined ? item.visible : true">
              <vuetify-text-field
                v-if="item.type === 'text-field' || item.type === 'password' || item.type === 'hidden'"
                v-model="item.value"
                :item="item"
                @on-change="onChange"
                @on-blur="onBlur"
              ></vuetify-text-field>
              <vuetify-select
                v-if="item.type === 'select'"
                v-model="item.value"
                :item="item"
                @on-add-item="onAddItem"
                @on-change="onChange"
              ></vuetify-select>
              <vuetify-date-picker
                v-if="item.type === 'date-picker'"
                :item="item"
                @on-change="onChange"
              ></vuetify-date-picker>
              <vuetify-time-picker
                v-if="item.type === 'time-picker'"
                :item="item"
                @on-change="onChange"
              ></vuetify-time-picker>
              <vuetify-radio-card
                ref="form"
                v-if="item.type === 'radio-card'"
                :options="item.options"
                :avatars="item.avatars"
                :aggregator="item.aggregator"
                v-model="item.selected"
                :rules="item.rules"
                @on-add-item="onAddItem"
              ></vuetify-radio-card>
              <vuetify-places-autocomplete
                v-if="item.type === 'places-autocomplete'"
                :item="item"
                :map-config="item.mapConfig"
                :rules="item.rules"
                v-model="item.value"
                @on-add-item="onAddItem"
              ></vuetify-places-autocomplete>
              <vuetify-switch
                v-if="item.type === 'switch'"
                :item="item"
                @on-add-item="onAddItem"
              ></vuetify-switch>
              <vuetify-checkbox
                v-if="item.type === 'checkbox'"
                :item="item"
                @on-change="onChange"
              ></vuetify-checkbox>
              <vuetify-link
                v-if="item.type === 'link'"
                :item="item"
              ></vuetify-link>
              <vuetify-radio-group
                v-if="item.type === 'radio-group'"
                :item="item"
                @on-change="onChange"
              ></vuetify-radio-group>
              <vuetify-slider
                v-if="item.type === 'slider'"
                :item="item"
                @on-change="onChange"
              ></vuetify-slider>
              <v-btn
                :disabled="item.loading || item.disabled || false"
                v-if="item.type === 'button' && !item.items"
                :class="setClassButton(item)"
                :color="item.color || 'primary'"
                @click="openNewWindow(item); onClickButton(item);"
                :outline="item.outline || false"
                :small="item.small || false"
                :round="item.round || false"
                :loading="item.loading || false"
              >{{ item.text_button || 'Submit' }}
              </v-btn>
              <v-btn
                :disabled="button.loading || button.disabled || false"
                v-if="item.type === 'button' && item.items"
                v-for="(button, i) in item.items || []" :key="i"
                :class="setClassButton(button)"
                :color="button.color || 'primary'"
                @click="openNewWindow(button); onClickButton(button);"
                :outline="button.outline || false"
                :small="button.small || false"
                :round="button.round || false"
                :loading="button.loading || false"
              >{{ button.text_button || 'Submit' }}
              </v-btn>
              <span
                class="section"
                v-if="item.type === 'section-text'"
              >
                <v-icon
                  class="section-icon"
                  v-if="item.append_icon"
                  :color="item.icon_color || 'primary'"
                >{{ item.append_icon }}</v-icon>
               <span :class="[item.class]">{{ item.value }}</span>
              </span>
              <div v-if="item.type === 'plain-text'">
                <div class="input-group input-group--dirty input-group--text-field primary--text">
                  <label>{{ item.label }}</label>
                  <div class="menu edit-dialog" style="display: inline-block;">
                    {{
                      (item.value || {}).item_text ||
                      (item.value || {}).commerce_name ||
                      (item.value || {}).installer_alias ||
                      (item.value || {}).seller_name ||
                      item.value ||
                      '' 
                    }}
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>

'use strict'

import VuetifyTextField from './fields/vuetify-text-field'
import VuetifySelect from './fields/vuetify-select'
import VuetifyDatePicker from './fields/vuetify-date-picker'
import VuetifyTimePicker from './fields/vuetify-time-picker'
import VuetifyRadioCard from './fields/vuetify-radio-card/vuetify-radio-card'
import VuetifySelectFile from './fields/vuetify-select-file'
import VuetifyPlacesAutocomplete from './fields/vuetify-places-autocomplete'
import VuetifySwitch from './fields/vuetify-switch'
import VuetifyRadioGroup from './fields/vuetify-radio-group'
import VuetifyCheckbox from './fields/vuetify-checkbox'
import VuetifyLink from './fields/vuetify-link'
import VuetifySlider from './fields/vuetify-slider'

export default {

  name: 'VuetifyFormCreator',

  components: {
    VuetifyTextField,
    VuetifySelect,
    VuetifyDatePicker,
    VuetifyTimePicker,
    VuetifyRadioCard,
    VuetifySelectFile,
    VuetifyPlacesAutocomplete,
    VuetifySwitch,
    VuetifyRadioGroup,
    VuetifyCheckbox,
    VuetifyLink,
    VuetifySlider
  },

  data: () => ({
    fields: [],
    isValid: false,
    loader: null,
    newWindowContent: null
  }),

  props:
  {
    columns: {
      type: String,
      default: 'xs12 sm10 md8 lg6'
    },
    items: {
      type: Array,
      default: null,
      required: true
    },
    validate: {
      type: Boolean,
      default: false,
      required: false
    },
    fluid: {
      type: Boolean,
      default: true,
      required: false
    },
    validateOnChanged: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  created () {
    this.normalizeParams(this.items)
  },

  methods: {
    /**
     * Normalize parameters by adding optional parameters.
     *
     * @param {Object} self
     */
    normalizeParams (items) {
      this.fields = []
      let self = this
      items.map(function (obj, index) {
        obj.index = obj.index || index
        obj.valid = obj.valid || false
        self.fields.push(obj)
        return obj
      })
      if (this.validateOnChanged) {
        this.validateForm()
      }
    },
    validateForm () {
      if (this.$refs.form_creator) {
        this.isValid = this.$refs.form_creator.validate()
        return this.isValid
      }
      return false
    },
    reset () {
      this.$refs.form_creator.reset()
    },
    openNewWindow (item) {
      if (item.open_new_window) {
        if (this.newWindowContent === null || (this.newWindowContent && this.newWindowContent.closed)) {
          this.newWindowContent = window.open('', '_blank')
        }
      }
    },

    onAddItem (...params) {
      this.$emit('on-add-item', ...params)
    },
    /*
    onKeyup (...params) {
      this.$emit('update:validate', this.isValid)
    },
    */
    onClickButton (item) {
      // console.log('-------------', item)
      item.newWindowContent = this.newWindowContent
      if (item.loading === false) {
        item.loading = true
      }
      if (item.validate_on_click) {
        this.validateForm()
      }
      this.$emit('on-click-button', item, this.isValid)
    },
    onChange (...params) {
      this.$emit('on-change', ...params)
    },
    onBlur (...params) {
      this.$emit('on-blur', ...params)
    },
    setClassButton (item) {
      let align = ''
      switch (item.align || '') {
        case 'left':
          align = 'align-btn-left'
          break
        case 'right':
          align = 'align-btn-right'
          break
        case 'center':
          align = 'align-btn-center'
          break
      }
      return align
    }
  },

  watch: {
    items: {
      handler: function (newVal, oldVal) {
        this.normalizeParams(newVal)
      },
      deep: true
    },
    isValid: {
      handler: function (newVal, oldVal) {
        this.$emit('update:validate', newVal)
      },
      deep: true
    }
  }
}
</script>


<style lang="sass">

.align-btn-left
  float: left

.align-btn-right
  float: right

.align-btn-center
  margin: auto
  display: block

.hidden
  display: none

.section-icon
  margin-top: -4px

.input-group__error
  color: #f44336 !important
</style>



// WEBPACK FOOTER //
// src/components/vuetify-form-creator/vuetify-form-creator.vue